<template>
  <div>
    <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>移動設定</h2>
        </div>
        <div v-if="errorMessage.text" class="error_message">
          {{ errorMessage.text }}<br>
        </div>
        <div v-for="(errorMessage, idx) in errorMessages" :key="idx" class="error_message">
          {{ errorMessage }}
        </div>
        <div class="input-area">
          <div class="top-form">
            <div>
              <span class="label">上：</span>
              <input type="number" v-model="top" :disabled="!isMoveY">
              <div class="max-dist" v-if="isMoveY && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxTopDist) + 'mm' }}</div>
            </div>
            <div>
              <span class="label">後：</span>
              <input type="number" v-model="back" :disabled="!isMoveZ">
              <div class="max-dist" v-if="isMoveZ && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxBackDist) + 'mm' }}</div>
            </div>
          </div>
          <div class="middle-form">
            <div class="rigth-left-form">
              <span class="label">左：</span>
              <input type="number" v-model="left" :disabled="!isMoveX">
              <div class="max-dist" v-if="isMoveX && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxLeftDist) + 'mm' }}</div>
            </div>
            <div>
              <svg width="260" height="260" viewBox="0 0 260 260">
                  <!-- 立方体 -->
                  <rect x="100" y="100" width="60" height="60" stroke="black" fill="white"/>
                  <line x1="100" y1="100" x2="120" y2="80" z="0" stroke="black"/>
                  <line x1="160" y1="100" x2="180" y2="80" z="0" stroke="black"/>
                  <line x1="160" y1="160" x2="180" y2="140" z="0" stroke="black"/>
                  <line x1="120" y1="80" x2="180" y2="80" z="0" stroke="black"/>
                  <line x1="180" y1="80" x2="180" y2="140" z="0" stroke="black"/>
                  <!-- 矢印中央線 -->
                  <line x1="140" y1="60" x2="140" y2="10" z="0" stroke="black"/>
                  <path d="M 145 15 l -5 -5 l 5 -5" transform="rotate(90, 140, 10)"/>
                  <line x1="80" y1="130" x2="30" y2="130" z="0" stroke="black"/>
                  <path d="M 35 135 l -5 -5 l 5 -5" transform="rotate(0, 30, 130)"/>
                  <line x1="200" y1="130" x2="250" y2="130" z="0" stroke="black"/>
                  <path d="M 255 135 l -5 -5 l 5 -5" transform="rotate(180, 250, 130)"/>
                  <line x1="140" y1="180" x2="140" y2="230" z="0" stroke="black"/>
                  <path d="M 145 235 l -5 -5 l 5 -5" transform="rotate(270, 140, 230)"/>
                  <line x1="200" y1="80" x2="240" y2="40" z="0" stroke="black"/>
                  <path d="M 245 45 l -5 -5 l 5 -5" transform="rotate(135, 240, 40)"/>
                  <line x1="90" y1="180" x2="50" y2="220" z="0" stroke="black"/>
                  <path d="M 55 225 l -5 -5 l 5 -5" transform="rotate(315, 50, 220)"/>
              </svg>
            </div>
            <div class="rigth-left-form">
              <span class="label">右：</span>
              <input type="number" v-model="right" :disabled="!isMoveX">
              <div class="max-dist" v-if="isMoveX && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxRightDist) + 'mm' }}</div>
            </div>
          </div>
          <div class="bottom-form">
            <div>
              <span class="label">前：</span>
              <input type="number" v-model="front" :disabled="!isMoveZ">
              <div class="max-dist" v-if="isMoveZ && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxFrontDist) + 'mm' }}</div>
            </div>
            <div>
              <span class="label">下：</span>
              <input type="number" v-model="bottom" :disabled="!isMoveY">
              <div class="max-dist" v-if="isMoveY && !isFreeMoveSpace">{{ '移動可能距離：' + round(maxBottomDist) + 'mm' }}</div>
            </div>
          </div>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onOk">設定</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as SpaceUtil from '../../../utils/Space'
import * as CalcUtil from '../../../utils/Calc'
import {API_URL, KEY_CODE} from '../../../constants/App'
import {PLANNING_TYPE, EDIT_TYPE, VIEW_TYPE, ATTRIBUTE_KEY, AXIS_TYPE, FACE_TYPE} from '../../../constants/Type'

export default {
  name: 'SetMovingModal',
  components: {},
  props: {
    fileData: Object,
    editCtrlSpaces: Array,
    globalSpaceMap: Map
  },
  data () {
    return {
      modalShown: false,
      editSpace: '',
      addTargetSpace: '',
      spaceJoincd: String,
      /** 移動設定値 */
      right: 0,
      left: 0,
      top: 0,
      bottom: 0,
      front: 0,
      back: 0,
      /** 最大移動距離 */
      maxRightDist: 0.0,
      maxLeftDist: 0.0,
      maxTopDist: 0.0,
      maxBottomDist: 0.0,
      maxFrontDist: 0.0,
      maxBackDist: 0.0,
      /** 移動方向フラグ */
      isMoveX: false,
      isMoveY: false,
      isMoveZ: false,
      errorMessages: [],
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      fieldErrorMessages: {}
    }
  },
  computed: {
    isFreeMoveSpace: function () {
      return [PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.COMBINE,
        PLANNING_TYPE.SETPLAN, PLANNING_TYPE.UNIT_SURFACE].includes(this.editSpace.planningType)
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    // *****************************************************************
    // モーダル表示
    // *****************************************************************
    /** モーダル表示 */
    showModal: function () {
      this.clearData()
      this.modalShown = true
      if (!this.editCtrlSpaces) {
        this.modalShown = false
        return
      }
      this.editSpace = this.editCtrlSpaces[0]
      switch (this.editSpace.planningType) {
        // 棚と中仕切り
        case PLANNING_TYPE.UNIT_INFILL:
        case PLANNING_TYPE.UNIT_SHELF:
          let alignAtt = this.fileData.attributeModelList.find(att => {
            return ATTRIBUTE_KEY.UT_FLAG_ALIGN_DIR === att.attKeycd && att.spaceId === this.editSpace.id
          })
          if (alignAtt != null) {
            switch (alignAtt.attString1) {
              case AXIS_TYPE.X:
                this.isMoveX = true
                break
              case AXIS_TYPE.Y:
                this.isMoveY = true
                break
              case AXIS_TYPE.Z:
                this.isMoveZ = true
                break
            }
          }
          this.setMaxMoveDistance()
          break
        // 引き出しは上下のみ
        case PLANNING_TYPE.UNIT_DRAWER:
          this.isMoveY = true
          this.setMaxMoveDistance()
          break
        // 表面オプション
        case PLANNING_TYPE.UNIT_FACE_OPTION:
          let faceOpAttr = this.getUtFaceOpInfoAttr()
          switch (faceOpAttr.attString2) {
            case FACE_TYPE.LEFT:
            case FACE_TYPE.RIGHT:
              this.isMoveY = true
              this.isMoveZ = true
              break
            case FACE_TYPE.TOP:
            case FACE_TYPE.BOTTOM:
              this.isMoveX = true
              this.isMoveZ = true
              break
            case FACE_TYPE.FRONT:
            case FACE_TYPE.BACK:
              this.isMoveX = true
              this.isMoveY = true
              break
          }
          this.setMaxMoveDistance()
          break
        default:
          this.isMoveX = true
          this.isMoveY = true
          this.isMoveZ = true
          break
      }
      this.spaceJoincd = this.editCtrlSpaces[0].spaceJoincd
    },
    /** 最大移動値を設定 */
    setMaxMoveDistance: function () {
      let editSpace = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === this.editSpace.id)
      let nextCells = {}
      switch (this.editSpace.planningType) {
        // 固定棚は隣セルとの距離
        case PLANNING_TYPE.UNIT_SHELF:
          nextCells = SpaceUtil.getNextCellsOfShelf(this.fileData, editSpace, this.globalSpaceMap)
          if (this.isMoveX) {
            this.maxRightDist = nextCells.right ? nextCells.right.w : 0
            this.maxLeftDist = nextCells.left ? nextCells.left.w : 0
          } else if (this.isMoveY) {
            this.maxTopDist = nextCells.top ? nextCells.top.h : 0
            this.maxBottomDist = nextCells.bottom ? nextCells.bottom.h : 0
          } else if (this.isMoveZ) {
            this.maxBackDist = nextCells.back ? nextCells.back.d : 0
            this.maxFrontDist = nextCells.front ? nextCells.front.d : 0
          }
          break
        // 可動棚は親セルとの距離
        case PLANNING_TYPE.UNIT_INFILL:
          let parentCell = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === this.editSpace.parentSpaceId)
          if (this.isMoveX) {
            this.maxRightDist = parentCell ? (parentCell.x + parentCell.w) - (this.editSpace.x + this.editSpace.w) : 0
            this.maxLeftDist = parentCell ? this.editSpace.x - parentCell.x : 0
          } else if (this.isMoveY) {
            this.maxTopDist = parentCell ? (parentCell.y + parentCell.h) - (this.editSpace.y + this.editSpace.h) : 0
            this.maxBottomDist = parentCell ? this.editSpace.y - parentCell.y : 0
          } else if (this.isMoveZ) {
            this.maxFrontDist = parentCell ? (parentCell.z + parentCell.d) - (this.editSpace.z + this.editSpace.d) : 0
            this.maxBackDist = parentCell ? this.editSpace.z - parentCell.z : 0
          }
          break
        // 引き出し
        case PLANNING_TYPE.UNIT_DRAWER:
          nextCells = SpaceUtil.getNextCellsOfDrawer(this.fileData, editSpace, this.globalSpaceMap)
          if (!nextCells.top || (nextCells.top.childrenSpaceModel[0] &&
          nextCells.top.childrenSpaceModel[0].planningType === PLANNING_TYPE.UNIT_DRAWER)) {
            this.maxTopDist = 0
          } else {
            this.maxTopDist = nextCells.top.h
          }
          if (!nextCells.bottom || (nextCells.bottom.childrenSpaceModel[0] &&
          nextCells.bottom.childrenSpaceModel[0].planningType === PLANNING_TYPE.UNIT_DRAWER)) {
            this.maxBottomDist = 0
          } else {
            this.maxBottomDist = nextCells.bottom.h
          }
          break
        // 表面オプション
        case PLANNING_TYPE.UNIT_FACE_OPTION:
          // 表面オプションのアトリビュート情報
          let faceOpAttr = this.getUtFaceOpInfoAttr()

          // 相手対象空間の取得
          let parentUnit = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === this.editSpace.parentSpaceId)
          let targetSpace = parentUnit.childrenSpaceModel.find(s => faceOpAttr.attString5.split('|')[0] === String(s.spaceObjectDtlType))

          // 相手対象面X/Y禁足
          let restMinX = faceOpAttr.attValue1 != null ? faceOpAttr.attValue1 : 0
          let restMaxX = faceOpAttr.attValue2 != null ? faceOpAttr.attValue2 : 0
          let restMinY = faceOpAttr.attValue3 != null ? faceOpAttr.attValue3 : 0
          let restMaxY = faceOpAttr.attValue4 != null ? faceOpAttr.attValue4 : 0

          // ローカル座標を持つ編集対象の空間
          let editSpaceLocal = SpaceUtil.searchSpaceTree(this.editSpace.id, this.fileData.topSpaceModel)

          // 座標と長さの合計値
          let topX = editSpaceLocal.x + editSpaceLocal.w
          let topY = editSpaceLocal.y + editSpaceLocal.h
          let topZ = editSpaceLocal.z + editSpaceLocal.d

          // 相手基準面ごとに最大移動値を設定
          switch (faceOpAttr.attString2) {
            case FACE_TYPE.LEFT:
              this.maxBottomDist = editSpaceLocal.y - targetSpace.y - restMinY
              this.maxTopDist = (targetSpace.h - restMaxY) - topY
              this.maxBackDist = editSpaceLocal.z - targetSpace.z - restMinX
              this.maxFrontDist = (targetSpace.d - restMaxX) - topZ
              break
            case FACE_TYPE.RIGHT:
              this.maxBottomDist = editSpaceLocal.y - targetSpace.y - restMinY
              this.maxTopDist = (targetSpace.h - restMaxY) - topY
              this.maxBackDist = editSpaceLocal.z - targetSpace.z - restMaxX
              this.maxFrontDist = (targetSpace.d - restMinX) - topZ
              break
            case FACE_TYPE.TOP:
              this.maxLeftDist = editSpaceLocal.x - targetSpace.x - restMinX
              this.maxRightDist = (targetSpace.w - restMaxX) - topX
              this.maxBackDist = editSpaceLocal.z - targetSpace.z - restMaxY
              this.maxFrontDist = (targetSpace.d - restMinY) - topZ
              break
            case FACE_TYPE.BOTTOM:
              this.maxLeftDist = editSpaceLocal.x - targetSpace.x - restMinX
              this.maxRightDist = (targetSpace.w - restMaxX) - topX
              this.maxBackDist = editSpaceLocal.z - targetSpace.z - restMinY
              this.maxFrontDist = (targetSpace.d - restMaxY) - topZ
              break
            case FACE_TYPE.FRONT:
              this.maxLeftDist = editSpaceLocal.x - targetSpace.x - restMinX
              this.maxRightDist = (targetSpace.w - restMaxX) - topX
              this.maxBottomDist = editSpaceLocal.y - targetSpace.y - restMinY
              this.maxTopDist = (targetSpace.h - restMaxY) - topY
              break
            case FACE_TYPE.BACK:
              this.maxLeftDist = editSpaceLocal.x - targetSpace.x - restMinX
              this.maxRightDist = (targetSpace.w - restMaxX) - topX
              this.maxBottomDist = editSpaceLocal.y - targetSpace.y - restMinY
              this.maxTopDist = (targetSpace.h - restMaxY) - topY
              break
            default:
              break
          }
          break
        default:
          break
      }
    },
    /** 表面オプションのアトリビュートを取得 */
    getUtFaceOpInfoAttr: function () {
      return this.fileData.attributeModelList.find(att => {
        return ATTRIBUTE_KEY.UT_FACEOP_INFO === att.attKeycd && att.spaceId === this.editSpace.id
      })
    },
    // *****************************************************************
    // 移動値を設定
    // *****************************************************************
    /** 移動値を設定 */
    setMovingDistance: function () {
      this.checkMaxMoveDistance()
      // 引き出し
      if ([PLANNING_TYPE.UNIT_DRAWER].includes(this.editSpace.planningType)) {
        let editCtrlSpaces = this.editCtrlSpaces.map(e => Object.assign({}, e))
        editCtrlSpaces[0].y = editCtrlSpaces[0].y + parseInt(this.top !== 0.0 ? this.top : -this.bottom)
        this.addTargetSpace = SpaceUtil.getAddTargetSpaceByEditTargetSpace(this.fileData, editCtrlSpaces, this.globalSpaceMap)
      }
      if (this.errorMessages.length > 0) {
        return
      }
      let dx = this.right > 0 ? this.right : -this.left
      let dy = this.top > 0 ? this.top : -this.bottom
      let dz = this.front > 0 ? this.front : -this.back
      let payload = {
        spaceJoincd: this.spaceJoincd,
        spaceIds: this.editCtrlSpaces.map(space => space.id),
        destSpaceId: this.addTargetSpace ? this.addTargetSpace.id : null,
        editType: EDIT_TYPE.MOVE,
        viewType: VIEW_TYPE.FRONT.code,
        dx: dx,
        dy: dy,
        dz: dz
      }
      axios.post(API_URL.PLANNING + '/move', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.modalShown = false
            this.clearMessages()
            this.$emit('setResponseData', response)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** 入力エラー・移動範囲チェック */
    checkMaxMoveDistance: function () {
      this.errorMessages = []
      // 共通入力チェック
      if (this.bottom === '' || this.bottom < 0 || this.top === '' || this.top < 0 ||
        this.right === '' || this.right < 0 || this.left === '' || this.left < 0 ||
        this.front === '' || this.front < 0 || this.back === '' || this.back < 0) {
        this.errorMessages.push('移動距離は0より大きい値を指定してください。')
      }
      if (this.bottom > 0 && this.top > 0) {
        this.errorMessages.push('移動寸法は上下のどちらか一方しか指定できません。')
      }
      if (this.right > 0 && this.left > 0) {
        this.errorMessages.push('移動寸法は左右のどちらか一方しか指定できません。')
      }
      if (this.front > 0 && this.back > 0) {
        this.errorMessages.push('移動寸法は前後のどちらか一方しか指定できません。')
      }
      // 自由配置空間以外は、移動可能範囲をチェック
      if (!this.isFreeMoveSpace) {
        if (this.maxRightDist < this.right || this.maxLeftDist < this.left ||
          this.maxFrontDist < this.front || this.maxBackDist < this.back ||
          this.maxTopDist < this.top || this.maxBottomDist < this.bottom) {
          this.errorMessages.push('移動可能範囲を超えています。')
        }
      }
    },
    // *****************************************************************
    // イベント処理
    // *****************************************************************
    /** 設定ボタン押下時 */
    onOk: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.clearMessages()
      this.setMovingDistance()
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.clearData()
      this.modalShown = false
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        event.keyCode === KEY_CODE.ENTER
      ) {
        this.onOk(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    // *****************************************************************
    // その他
    // *****************************************************************
    round: function (value) {
      return CalcUtil.round(value, 2)
    },
    clearData: function () {
      this.isMoveX = false
      this.isMoveY = false
      this.isMoveZ = false
      this.right = 0
      this.left = 0
      this.top = 0
      this.bottom = 0
      this.front = 0
      this.back = 0
    },
    clearMessages: function () {
      this.errorMessages = []
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {}
    }
  }
}
</script>

<style scoped lang="scss">
.input-area {
  overflow: auto;
  max-height: calc(100% - 110px);
  >div {
    >div{
      min-width: 180px;
    }
    input {
      width: 80px
    }
  }
  .top-form {
    display: flex;
    justify-content: right;
    margin-right: 26px;
    >div{
      width: 220px;
      height: 64px;
    }
  }
  .middle-form {
    display: flex;
    justify-content: center;
    align-items: center;
    .rigth-left-form{
      width: 220px;
    }
  }
  .bottom-form {
    display: flex;
    justify-content: left;
    margin-left: 26px;
    >div{
      width: 260px;
      height: 64px;
    }
  }
}
.max-dist{
  margin-left: 50px;
}

.label {
  display: inline-block;
  text-align: right;
  min-width: 50px;
}
.error_message {
  margin-top: 5px;
  margin-bottom: 5px ;
}
input.sm {
  width: 60px;
}

.modal .modal-main {
  width: 50%;
  max-width: 60%;
  max-height: 70%;
}
.modal .modal-main .input-area {
  padding: 20px 0px;
}

</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetMovingDistanceModal.vue